import sessionReader from '../../../store/readHelpers/SessionReader';

import { t } from '../../../services/i18nService';

// Show next button anyway upon and after 3rd consecutive rejection.
const relaxedThreshold = 3;

const relaxedNextButtonSelector = {
    selectShowNextAnyway(approved, consecutiveRejections) {
        return (
            sessionReader.isRelaxedAutomaticIdVerificationEnabled()
            && !approved
            && consecutiveRejections >= relaxedThreshold
        );
    },

    selectNextAnywayMessage() {
        return t('idVerification.idCard.nextAnyway');
    },

    mapStateToProps({ idverification }, { approved }) {
        return {
            nextAnywayMessage: this.selectNextAnywayMessage(),
            showNextAnyway: this.selectShowNextAnyway(
                approved,
                idverification.consecutiveRejections,
            ),
        };
    },
};

export default relaxedNextButtonSelector;
